import { GoPeople } from "react-icons/go";
import { FiAward } from "react-icons/fi";
import { FaRegStar } from "react-icons/fa";
import "./index.css";
import React, { useContext, useEffect } from "react";
import CourseCards from "../CourseSection";
// import CallRequestModel from "../CallRequestModel";
import { IoCallOutline } from "react-icons/io5";
import TrustedByStudents from "../TrustedBy";
import TrustedByCompanies from "../TrustedByCompanies";
import RecognisedBy from "../RecognisedBy";
import NRITeam from "../NRITeam";
import SuccessMetrics from "../SuccessMetrics";
import SuccessStories from "../SuccessStories";
import MentorSupport from "../MentorSupport";
import CompanyRoadmap from "../CompanyRoadmap";
import FounderSection from "../IBIXTeam";
import { AppContext } from "../../context/AppContext";
import { Helmet } from "react-helmet-async";

const Home = () => {
  const { homeRef, setModalShow, setActiveRoute } = useContext(AppContext);
  useEffect(() => {
    setActiveRoute("/");
  }, [setActiveRoute]);

  function mobileAppShow() {
    return (
      <div className="d-flex justify-content-center align-items-center mobile-app-container">
        <div
          className="text-white d-flex flex-md-row flex-column justify-content-center shadow-lg mobile-phone-card p-0"
          style={{
            background:
              "linear-gradient(135deg, #1e2a78, #2b3fa0, #3c55d1, #4b6cff, #5c7bff, #7a89ff, #9faeff)",
          }}
        >
          {/* HERO SECTION */}
          <div className="hero-wrapper">
            <div className="hero-container">
              {/* LEFT */}
              <div className="hero-left">
                <span className="hero-badge">🚀 Learn Smarter</span>

                <h1 className="hero-title">
                  Learn from anywhere,
                  <br />
                  <span>Build your future</span>
                </h1>

                <p className="hero-subtitle">
                  Access IBIX courses anytime. Master in-demand skills, get
                  placed faster, and transform your career with real-world
                  training.
                </p>

                <div className="hero-buttons">
                  <a href="/courses/fullstack" className="btn-primary">
                    Explore Courses
                  </a>

                  <a
                    href="https://learning.ibixqt.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-secondary"
                  >
                    Login
                  </a>
                </div>
              </div>

              {/* RIGHT */}
              <div className="hero-right">
                <img
                  src="https://iqteche.in/static/media/wl_client_images/5f616c400cef4456a12d7f7ef3c0a119.png"
                  alt="app"
                />
              </div>
            </div>
          </div>
        </div>{" "}
        {/* ✅ THIS WAS MISSING */}
      </div>
    );
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>IBIX Advanced Tech Certification Courses</title>
        <link rel="canonical" href="https://ibixqt.in/" />
        <meta
          name="description"
          content=" IBIX topmost software training institute in Hyderabad to master AI, ML, and Data Science. Learn from experts, build projects, earn certification and be job-ready."
        />
      </Helmet>
      <div className="home-section-bg-container" ref={homeRef}>
        <section className="home-section text-center ">
          <span className=" banner-quotes">⭐ Learn Today - Lead Tomorrow</span>

          <div className="d-flex flex-column align-items-center">
            <h1>
              Transform Your Career with{" "}
              <span className="heading-span">Industry-Ready Tech Skills</span>
            </h1>
            <p className="home-section-description">
              Join India's most trusted tech education platform. Learn from
              industry experts, work on real projects, and get guaranteed job
              placement with top companies.
            </p>
          </div>

          <div className="about-home-banner d-flex justify-content-center align-items-center">
            <div className="home-about-banner-card shadow d-flex justify-content-center">
              <div className="home-banner-icon-container d-flex justify-content-center align-items-center">
                <GoPeople className="banner-card-icon" />
              </div>
              <div className="banner-about-info">
                <h3>5,000 +</h3>
                <p className="banner-about-info-para">Students Trained</p>
              </div>
            </div>

            <div className="home-about-banner-card shadow d-flex justify-content-center">
              <div className="home-banner-icon-container d-flex justify-content-center align-items-center">
                <FiAward className="banner-card-icon" />
              </div>
              <div className="banner-about-info">
                <h3>10+</h3>
                <p className="banner-about-info-para">4.0 Tech Courses</p>
              </div>
            </div>

            <div className="home-about-banner-card shadow d-flex justify-content-center">
              <div className="home-banner-icon-container d-flex justify-content-center align-items-center">
                <FaRegStar className="banner-card-icon" />
              </div>
              <div className="banner-about-info">
                <h3>4.8/5</h3>
                <p className="banner-about-info-para">Student Rating</p>
              </div>
            </div>
          </div>
          <button
            className="call-req-button"
            onClick={() => setModalShow(true)}
          >
            <IoCallOutline className="phone-icon" /> Book Free Career
            Counselling
          </button>
          {/* <CallRequestModel /> */}
        </section>
        <CourseCards />
      </div>
      <TrustedByStudents />
      <TrustedByCompanies />

      <RecognisedBy />
      <NRITeam />
      <SuccessMetrics />
      <SuccessStories />
      <MentorSupport />
      <CompanyRoadmap />
      <FounderSection />
      {mobileAppShow()}
    </React.Fragment>
  );
};

export default Home;
